import { create } from 'zustand';
import type { UserDto } from '../api/types';

interface AuthState {
  user: UserDto | null;
  accessToken: string | null;
  accessTokenExpiresAt: string | null;
  isAuthenticated: boolean;
  setSession: (user: UserDto, token: string, expiresAt: string) => void;
  setUser: (user: UserDto) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  accessToken: null,
  accessTokenExpiresAt: null,
  isAuthenticated: false,
  setSession: (user, accessToken, accessTokenExpiresAt) =>
    set({ user, accessToken, accessTokenExpiresAt, isAuthenticated: true }),
  setUser: (user) => set({ user }),
  clear: () => set({ user: null, accessToken: null, accessTokenExpiresAt: null, isAuthenticated: false }),
}));
